import { ObjectType } from '@/@types/graphql-types';

const getTitleContextEntityId = (objectType: ObjectType, objectId: number) => {
	let str = 't';
	switch (objectType) {
		case ObjectType.Movie:
			str += 'm';
			break;
		case ObjectType.Show:
		case ObjectType.ShowEpisode:
			str += 's';
			break;
		case ObjectType.ShowSeason:
			str += 'ss';
			break;
		case ObjectType.Person:
			str += 'p';
			break;
		default:
			console.error(`[ERROR] ${objectType} is not a valid object type`);
	}
	return str + `${objectId}`;
};

export { getTitleContextEntityId };
